// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************

let windowHeight = window.innerHeight / 1.5;

const debounceUpdateHeights = debounce(() => {
  windowHeight = window.innerHeight / 1.5;
}, 50);

debounceUpdateHeights();

window.addEventListener('resize', debounceUpdateHeights);

function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > windowHeight);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});
